import React from 'react';

const Videos = () => {
  const ponencias = [
    {
      id: 1,
      title: "Intervención en Trastorno Obsesivo Compulsivo",
      subtitle: "desde el enfoque Cognitivo Conductual",
      speaker: "Lic. José Luis Riojas Luna",
      organization: "IPSICOC",
      videoId: "PA2qJfmyPUg"
    },
    {
      id: 2,
      title: "Manejo de Ansiedad y Ataques de Pánico",
      subtitle: "desde el enfoque Cognitivo-Conductual",
      speaker: "Lic. José Luis Riojas Luna",
      organization: "IPSICOC",
      videoId: "mkIql0ygv8k"
    },
    {
      id: 3,
      title: "Prevención del Abuso Sexual Infantil",
      subtitle: "",
      speaker: "Lic. José Luis Riojas Luna",
      organization: "CEPESEX",
      videoId: "5YDXs5AavYo"
    },
    {
      id: 4,
      title: "¿Cómo cuidar nuestra Salud Mental",
      subtitle: "en tiempos de pandemia?",
      speaker: "Lic. José Luis Riojas Luna",
      organization: "CEPESEX",
      videoId: "Bf4Nz1zlWUw"
    },
    {
      id: 5,
      title: "Ansiedad producida como efecto colateral del COVID19",
      subtitle: "",
      speaker: "Lic. José Luis Riojas Luna",
      organization: "PSICOEDUCATIVA CLINICA",
      videoId: "Ju7i2zVGFOw"
    },
    {
      id: 6,
      title: "Ansiedad en tiempos de pandemia",
      subtitle: "",
      speaker: "Lic. José Luis Riojas Luna",
      organization: "CEPESEX",
      videoId: "kOfFRGStswY"
    }
  ];

  const reportajes = [
    {
      id: 1,
      title: "Noticiero: Buenos Días Perú",
      subtitle: "Nota sobre: Monstruo de Moche",
      videoId: "3jO9owl_tH4"
    },
    {
      id: 2,
      title: "Noticiero: Buenos Días Perú",
      subtitle: "Nota sobre: Joven Desaparecida",
      videoId: "l5hZLpU0OOg"
    },
    {
      id: 3,
      title: "Noticiero: Buenos Días Perú",
      subtitle: "Nota sobre: Pederasta el Buitre del Arenal",
      videoId: "M2lslRxMzmg"
    },
    {
      id: 4,
      title: "Noticiero: Buenos Días Perú",
      subtitle: "Nota sobre: Análisis Caso Parricidio",
      videoId: "bMh0dzBQ9Y8"
    },
    {
      id: 5,
      title: "Noticiero: Buenos Días Perú",
      subtitle: "Nota sobre: Raqueteros",
      videoId: "9z-_MLuM4v0"
    },
    {
      id: 6,
      title: "Noticiero: Buenos Días Perú",
      subtitle: "Nota sobre: El Asesino del Cilindro",
      videoId: "xta3qyA_gIc"
    },
    {
      id: 7,
      title: "Noticiero: Buenos Días Perú",
      subtitle: "Nota sobre: Feminicidio",
      videoId: "_OtRdFrUQOQ"
    },
    {
      id: 8,
      title: "Noticiero: Buenos Días Perú",
      subtitle: "Nota sobre: Pareja Asesina",
      videoId: "GJ_0QMLb4sk"
    },
    {
      id: 9,
      title: "Noticiero: Buenos Días Perú",
      subtitle: "Nota sobre: Violencia de Género",
      videoId: "sJ8CIbCUUzw"
    }
  ];

  return (
    <div className="videos-page" data-testid="videos-page">
      {/* Hero Section */}
      <section className="page-hero">
        <div className="container">
          <h1 className="heading-hero">Videoteca</h1>
          <p className="hero-subtitle body-large">
            Ponencias, entrevistas y contenido educativo sobre salud mental
          </p>
        </div>
      </section>

      {/* Ponencias Section */}
      <section className="videos-section">
        <div className="container">
          <div className="section-header">
            <h2 className="heading-1">Ponencias</h2>
          </div>

          <div className="videos-grid">
            {ponencias.map((video) => (
              <div key={video.id} className="video-card">
                <div className="video-embed">
                  <iframe
                    src={`https://www.youtube.com/embed/${video.videoId}`}
                    title={video.title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    loading="lazy"
                  ></iframe>
                </div>
                <div className="video-info">
                  <h3 className="heading-3">{video.title}</h3>
                  {video.subtitle && <p className="video-subtitle body-small">{video.subtitle}</p>}
                  <p className="video-details caption">
                    <strong>Ponente:</strong> {video.speaker}<br />
                    <strong>Invitación:</strong> {video.organization}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Reportajes Section */}
      <section className="videos-section reportajes-section">
        <div className="container">
          <div className="section-header">
            <h2 className="heading-1">Reportajes</h2>
          </div>

          <div className="videos-grid">
            {reportajes.map((video) => (
              <div key={video.id} className="video-card">
                <div className="video-embed">
                  <iframe
                    src={`https://www.youtube.com/embed/${video.videoId}`}
                    title={video.title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    loading="lazy"
                  ></iframe>
                </div>
                <div className="video-info">
                  <h3 className="heading-3">{video.title}</h3>
                  <p className="video-subtitle body-small">{video.subtitle}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2 className="heading-1">¿Necesitas Ayuda Profesional?</h2>
            <p className="body-large">
              Contáctanos y agenda tu cita con nuestro equipo de especialistas.
            </p>
            <a
              href="https://wa.me/51934442759"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary large"
            >
              CONTACTAR AHORA
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Videos;
